// Provides consistent date or time display format across the application.
// @see https://date-fns.org/v2.27.0/docs/format
export const dateFormats = {
  LongDate: 'd MMMM yyyy',
  ShortMonthLongDate: 'd MMM yyyy',
  LongDateTime: 'ha dddd MMMM d yyyy',
  ShortDate: 'dd/MM/yyyy',
  ShortDateTime: 'd MMMM yyyy HH:mm',
  ShortYearDate: 'dd/MM/yy',
  Short12hourClockDateTime: 'h:mma dd/MM/yy',
  Short12hourClockDateHour: 'ha dd/MM/yy',
  FilteringDate: 'yyyy-MM-dd'
};

export const defaultMinYear = 1900;
export const defaultMinDate = new Date(defaultMinYear, 0, 1)



// WEBPACK FOOTER //
// ./src/constants/date.js